import { render, staticRenderFns } from "./LedgerAccountBrowseEditCard.vue?vue&type=template&id=1ff1037a"
import script from "./LedgerAccountBrowseEditCard.vue?vue&type=script&lang=ts"
export * from "./LedgerAccountBrowseEditCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ff1037a')) {
      api.createRecord('1ff1037a', component.options)
    } else {
      api.reload('1ff1037a', component.options)
    }
    module.hot.accept("./LedgerAccountBrowseEditCard.vue?vue&type=template&id=1ff1037a", function () {
      api.rerender('1ff1037a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ledger-accounts/LedgerAccountBrowseEditCard.vue"
export default component.exports